// extracted by mini-css-extract-plugin
export default {"KanbanBoard":"KanbanBoard_KanbanBoard__3NB+w"};